import { Button, FormControl, TextField } from '@material-ui/core'
import { Provider as ErrorsStateContextProvider } from '@/hooks/ErrorsStateContext'
import { Provider as InputStateContextProvider } from '@/hooks/inputStateContext'
import { actions, useDispatch } from '@/redux'
import { makeStyles } from '@material-ui/core/styles'
import { useImmer } from 'use-immer'
import React from 'react'
import _ from 'lodash'

import { useMerchant } from '@/hooks/merchantContext'
import Dialog from '@/components/Dialog'
import config from '@/config'

const initialState = {
  username: '',
  password: '',
  name: '',
  address: '',
  contact: '',
  region: config.region?.toUpperCase(),
}
const availableRegions = config.region?.toUpperCase() === 'TH' ? ['TH'] : ['HK', 'TW']

// TH 稅務發票 seller 收據表頭的 address / phone 來自 merchant 主檔（merchant.address / merchant.contact），
// 依 PMO 字數上限設限（DMP-46）。僅 TH 部署設限，避免影響 HK / TW 既有流程。
// 註：seller company name 用 eInvoiceCompanyName（於 InvoiceSettings 設限 80），故此處不限制 name。
const isThRegion = config.region?.toUpperCase() === 'TH'
const TH_MERCHANT_FIELD_MAX_LENGTH = { address: 200, contact: 15 }
const thMaxLength = (key) => isThRegion ? { maxLength: TH_MERCHANT_FIELD_MAX_LENGTH[key] } : {}

/**
 *
 * @param {*} props
 * @returns
 */
export default function CreateDialog (props) {
  const dispatch = useDispatch()
  const classes = useStyles(props)
  const [errors, setErrors] = React.useState({})
  const [merchantState, setMerchant] = useMerchant()
  const [inputState, setInputState] = useImmer({})
  const updateInputState = (path, value) => {
    setInputState((draft) => {
      _.set(draft, path, value)
    })
  }

  const validateInput = React.useCallback(() => {
    const temp = {}
    if (_.isEmpty(_.trim(inputState.username))) {
      temp.username = 'Username is required'
    }
    if (_.isEmpty(_.trim(inputState.password))) {
      temp.password = 'Password is required'
    }
    if (_.isEmpty(_.trim(inputState.name))) {
      temp.name = 'Name is required'
    }
    setErrors(temp)
    if (!_.isEmpty(temp)) {
      dispatch(actions.app.toggleDialog('alertDialog', true, {
        title: 'Error',
        content: _.map(temp, message => `* ${message}`).join('\n'),
      }))
      return false
    }
    return true
  }, [dispatch, inputState.name, inputState.password, inputState.username])

  React.useEffect(() => {
    setInputState((draft) => {
      // 初始 inputState
      const newState = {
        ...initialState,

      }
      return newState
    })
  }, [merchantState.merchant])

  const open = merchantState.openCreateDialog

  const handleClose = () => {
    console.log('close')
    setMerchant('merchant', {})
    setMerchant('openCreateDialog', false)
    setErrors({})
  }

  const handleSubmit = async () => {
    const valid = validateInput()
    if (!valid) return
    console.log('debug', inputState)

    debugger
    try {
      await dispatch(actions.merchant.createMerchant(inputState))
      dispatch(actions.merchant.getMerchants())
    } catch (error) {
      dispatch(actions.app.toggleDialog('alertDialog', true, { title: 'Error', content: error.message }))
    } finally {
      handleClose()
    }
  }
  const handleChange = (e) => {
    const { name, value } = e.target
    updateInputState(name, value)
    setErrors({ ...errors, [name]: undefined })
  }

  return (
    <InputStateContextProvider value={[inputState, updateInputState]}>
      <ErrorsStateContextProvider value={[errors, setErrors]}>
        <Dialog
          title='Create New Merchant'
          open={open}
          handleClose={handleClose}
          renderActions={() => {
            return (
              <Button
                type='submit'
                variant='contained'
                color='primary'
                disableElevation
                onClick={handleSubmit}
              >
                Submit
              </Button>
            )
          }}
        >
          <div className={classes.content}>
            <FormControl variant='outlined' margin='dense' fullWidth>
              <TextField
                label='Username'
                name='username'
                type='text'
                required
                variant='outlined'
                size='small'
                fullWidth
                value={inputState.username}
                onChange={handleChange}
                error={Boolean(errors.username)}
              />
            </FormControl>
            <FormControl variant='outlined' margin='dense' fullWidth>
              <TextField
                label='Password'
                name='password'
                type='text'
                required
                variant='outlined'
                size='small'
                fullWidth
                value={inputState.password}
                onChange={handleChange}
                error={Boolean(errors.password)}
              />
            </FormControl>
            <FormControl variant='outlined' margin='dense' fullWidth>
              <TextField
                label='Name'
                name='name'
                type='text'
                required
                variant='outlined'
                size='small'
                fullWidth
                value={inputState.name}
                onChange={handleChange}
                error={Boolean(errors.name)}
              />
            </FormControl>
            <FormControl variant='outlined' margin='dense' fullWidth>
              <TextField
                label='Address'
                name='address'
                type='text'
                variant='outlined'
                size='small'
                fullWidth
                value={inputState.address}
                onChange={handleChange}
                error={Boolean(errors.address)}
                inputProps={thMaxLength('address')}
              />
            </FormControl>
            <FormControl variant='outlined' margin='dense' fullWidth>
              <TextField
                label='Contact'
                name='contact'
                type='text'
                variant='outlined'
                size='small'
                fullWidth
                value={inputState.contact}
                onChange={handleChange}
                error={Boolean(errors.contact)}
                inputProps={thMaxLength('contact')}
              />
            </FormControl>
            <FormControl variant='outlined' margin='dense' fullWidth>
              <TextField
                select
                label='Region'
                name='region'
                variant='outlined'
                size='small'
                fullWidth
                value={inputState.region || ''}
                onChange={handleChange}
                error={Boolean(errors.region)}
                SelectProps={{
                  native: true,
                }}
              >
                <option value='' disabled>
                  Select Region
                </option>
                {
              availableRegions.map((region) => (
                <option key={region} value={region}>
                  {region}
                </option>
              ))
            }
              </TextField>
            </FormControl>
          </div>
        </Dialog>
      </ErrorsStateContextProvider>
    </InputStateContextProvider>
  )
}

const useStyles = makeStyles(theme => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 400,
    padding: 8,
    gap: 8,
  },
}))
